module.exports = __webpack_public_path__ + "components/MapControl/svg/Zajazd.svg?dc910b81";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Zajazd.svg
// module id = 2052
// module chunks = 0